// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","loader-bounce":"Loader_loader-bounce__3W2FZ","bounce1":"Loader_bounce1__1tn9b","bounce2":"Loader_bounce2__nY-iW","bounce3":"Loader_bounce3__MQWsu"};